export enum RichTextEditorConfigFeatureEnum {
    enablePersonalizations,
    enableLineHeight,
    enableHeading,
    enableFontColor,
    enableBackgroundColor,
    enableHtmlEditor,
    enableAIHelper,
    enableAIRefinement,
    enableFontFamily,
    enableFontSize,
    enableInsertImage,
    enableStrikethrough,
    enableAlignment,
    enableNumberedList,
    enableBlockQuote,
    enableDirection,
    pastePlainText,
    enableTranslation
}
